/* eslint-disable no-undef */
import React from "react";
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { Container, Title } from '../../components';
import { getIdFromPath } from '../../utils/utils';
import { Image, Table, Card, Row, Col, Affix, Button } from "antd";
import { TITLE_LEVEL } from '../../utils/constants';
import { inspectionColumn, eventsColumn, reasonForRejectionColumn, establishmentColumn } from '../../utils/inspectionsColumns';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { GoogleMap, Polygon, useJsApiLoader, MarkerClusterer, Marker } from "@react-google-maps/api";
import { localeText, getDateFormattedInspection } from '../../utils/utils';
import flts from '../inspections-applications/index'

//https://react-google-maps-api-docs.netlify.app/ <--- Mapa



const InspectionApplicationDetailScreen = () => {
	const location = useLocation();
	console.log(location)
	const id = getIdFromPath(location.pathname);

	const inspection = useSelector((state) => state.inspectionApplications.inspectionApplications.filter(obj => obj.id == id)[0]);
	const history = useHistory();

	const containerStyle = {
		width: '100%',
		height: '400px'
	};

	const options = { imagePath:'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'}
	function createKey(location) { return location.lat + location.lng}
	const [top, setTop] = React.useState(10);
	const { isLoaded } = useJsApiLoader({
		id: 'google-map-script',
		googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
		language: "es"
	})
	const path = () => {
		let latLng = []
		inspection.upPolygonCoordinates.forEach(element => {
			latLng.push({
				lat: parseFloat(element.lat),
				lng: parseFloat(element.lng)
			})
		});
		return latLng
	}
	const pathInspector = () => {
		let latLng = []
		inspection.inspectorCoordinates.forEach(element => {
			latLng.push({
				lat: parseFloat(element.lat),
				lng: parseFloat(element.lng),
				pointDate: getDateFormattedInspection(element.pointDate)
			})
		});
		return latLng
	}

	const Space = () => (
		<div style={{ paddingBottom: 19 }} />
	);

	const [map, setMap] = React.useState(null)

	const onLoad = React.useCallback(function callback(map) {
		setMap(map)
	}, [])

	const onUnmount = React.useCallback(function callback(map) {
		setMap(null)
	}, [])

	const dataSourceInspector = [
		{
			id: inspection.id,
			inspectorInternalCode: inspection.inspectorInternalCode,
			inspectorFullName: inspection.inspectorFullName,
			createdAt: inspection.createdAt,
			startDate: inspection.startDate,
			endDate: inspection.endDate,
			currentStatus: inspection.currentStatus,
			inspectionType: inspection.inspectionType,
			inspectionStartDate: inspection.inspectionStartDate,
			inspectionEndDate: inspection.inspectionEndDate,
			key: "123"

		}
	];
	const dataSourceEstablishment = [
		{
			establishmentCode: inspection.establishmentCode,
			establishmentName: inspection.establishmentName,
			establishmentZone: inspection.establishmentZone,
			inspectionExportZone: inspection.inspectionExportZone,
			establishmentDirection: inspection.establishmentDirection,
			key: "123"

		}
	];

	return (
		<Container>	
			<Title level={TITLE_LEVEL}>Solicitud de inspección: {inspection.upCode}</Title>

			<Card>
				<Table
					scroll={{ x: 750 }}
					columns={inspectionColumn}
					dataSource={dataSourceInspector}
					pagination={false}
					locale={localeText}
				/>

				<Space />


				<Table
					scroll={{ x: 750 }}
					columns={establishmentColumn}
					dataSource={dataSourceEstablishment}
					pagination={false}
					locale={localeText}
				/>
			</Card>

			<Space />

			<Card>
				<Row>
					<Col flex="auto" style={{ marginRight: '10px' }}>
						{isLoaded ? <GoogleMap
							mapContainerStyle={containerStyle}
							mapContainerClassName="App-map"
							center={{ lat: parseFloat(inspection.upPolygonCoordinates[0].lat), lng: parseFloat(inspection.upPolygonCoordinates[0].lng) }}
							zoom={14}
							version="weekly"
							onLoad={onLoad}
							onUnmount={onUnmount}
							mapTypeId= 'satellite'
						>
							<Polygon
								path={path()}
							/>
							<MarkerClusterer options={options}>
								{(clusterer) =>
									pathInspector().map((location) => (
										<Marker key={createKey(location)} position={location} clusterer={clusterer} title={location.pointDate} />
									))
								}
							</MarkerClusterer>
						</GoogleMap>
							:
							<div style={{ width: 0 }} />
						}
					</Col>

					{inspection.inspectionRequestImages[0] ?
						<Col span={12} style={containerStyle}>
							<Image.PreviewGroup>
								<Carousel>
									{inspection.inspectionRequestImages.map(
										(image) => {
											return <Image style={containerStyle} key={image.id} src={image.url} preview={{ getContainer: '#root' }} />;
										}
									)}
								</Carousel>
							</Image.PreviewGroup>
						</Col>
						: <div style={{ width: 0 }} />
					}

				</Row>
			</Card>

			<Space />

			<Card>
				<h2>Eventos: </h2>

				{inspection.inspectionEvents.text}
				<Space />

				<div>
					{inspection.currentStatus != 'RECHAZADA' ?
						<div>
							<Table
								scroll={{ x: 750 }}
								columns={eventsColumn}
								pagination={false}
								locale={{ emptyText: 'No se registraron eventos' }}
								dataSource={inspection.inspectionEvents?.key?.map((event) => ({
									events: event
								}))}
								rowKey={(record) => record.id}
							/>
						</div> :
						<div>
							<Table
								scroll={{ x: 750 }}
								columns={reasonForRejectionColumn}
								pagination={false}
								locale={{ emptyText: 'No se registraron eventos' }}
								dataSource={inspection.reasonForRejection?.key?.map((reason) => ({
									reasons: reason
								}))}
								rowKey={(record) => record.id}
							/>
						</div>
					}
				</div>
			</Card>
		</Container >
	);
};

export default InspectionApplicationDetailScreen;
